import { useState, type KeyboardEvent } from 'react';

type Props = {
  values: string[];
  onChange: (next: string[]) => void;
  placeholder?: string;
};

export default function ChipList({ values, onChange, placeholder }: Props) {
  const [draft, setDraft] = useState('');

  const add = () => {
    const trimmed = draft.trim();
    if (!trimmed) return;
    onChange([...values, trimmed]);
    setDraft('');
  };

  const remove = (i: number) => {
    onChange(values.filter((_, idx) => idx !== i));
  };

  const onKey = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      add();
    }
    if (e.key === 'Backspace' && draft === '' && values.length > 0) {
      remove(values.length - 1);
    }
  };

  return (
    <div className="chip-input">
      {values.map((v, i) => (
        <span key={`${v}-${i}`} className="chip">
          {v}
          <button type="button" onClick={() => remove(i)} aria-label="حذف">
            ×
          </button>
        </span>
      ))}
      <input
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={onKey}
        onBlur={add}
        placeholder={placeholder ?? 'اضغط Enter بعد كل عنصر'}
      />
    </div>
  );
}
